import DOMPurify from 'isomorphic-dompurify';

export function chunk<T>(array: T[], chunkSize: number = 5): T[][] {
    if (!Array.isArray(array)) return [];
    const chunks: T[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
}

export function detectUsernameTypeDetailed(value: string): { type: string; label: string } {
    const trimmed = value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^(?:\+98|0098|0)?9\d{9}$/;

    if (emailRegex.test(trimmed)) {
        return { type: 'email', label: 'ایمیل' };
    }
    if (phoneRegex.test(trimmed)) {
        return { type: 'phone', label: 'شماره تلفن همراه' };
    }
    return { type: 'unknown', label: 'ناشناخته' };
}

export function sanitizeHtml(dirtyHtml: string): string {
    if (typeof dirtyHtml !== 'string') return '';

    const clean = DOMPurify.sanitize(dirtyHtml, {
        USE_PROFILES: { html: true }, // Safe HTML only (no SVG/MathML)
        ALLOWED_TAGS: [
            'a',
            'b',
            'i',
            'u',
            'strong',
            'em',
            'p',
            'br',
            'ul',
            'ol',
            'li',
            'span',
            'div',
            'img',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'blockquote',
            'code',
            'pre'
        ],
        ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'target', 'rel', 'class'],
        ALLOW_DATA_ATTR: false, // prevent data:* URLs
        FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'style']
    });

    return clean.trim();
}
